import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const Survey = Loadable({
    loader: () => import(/* webpackChunkName: "Survey" */ './survey'),
    loading: () => <div />,
});
